export default {
  LIST: {
    TITTLE: {
      TEXT: 'Portal Parceiro',
      BRAND: 'KMV'
    },
    CONTENT: {
      TITLE: 'Condições Comerciais',
      LABEL_CASH: 'Não se aplica',
      LABEL_SAME_AS_PAYMENT: 'Casada com o pagamento na conta do KMV'
    },
    LABEL_BUTTON: 'Declaro que li e aceito os termos acima',
    LOADING: 'Aguarde ...',
    REQUEST_MSG: {
      ERROR: 'Falha ao montar os termos e condições comerciais',
      SUCCESS: 'Tudo certo! Faça seu login novamente para ter acesso'
    }
  },
  GENERAL_DATA: {
    BOX_TITLE: 'Informações gerais ',
    DATA: [
      [
        {
          title: 'Taxa de juros por parcela',
          info: '1% a.m.'
        },
        {
          title: 'Quantidade máxima de parcelas',
          info: '12X'
        },
        {
          title: 'Valor mínimo de parcelas',
          info: 'R$ 50,00'
        }
      ],
      [
        {
          title: 'Frequência de pagamento',
          info: 'Semanal, às terças',
          alert:
            'Os pagamentos de recebíveis serão realizados conforme contrato vigente, seguindo a regra acima, desde que o dia escolhido não seja um feriado.'
        },
        {
          title: 'Tarifa TED',
          info: 'R$ 0,00',
          alert:
            'Você não possui tarifas para transferências TED. Tentativas feitas e não realizadas por um erro no banco destinatário não serão cobradas.'
        }
      ]
    ]
  },
  DETAILS_CONFIG: {
    boxTitle: 'Formas de pagamento, comissões e liquidações',
    header: [
      'Meios de pagamento',
      'Taxa de comissão do app',
      'Prazo de pagamento na conta KMV',
      'Programação de transferência (TED)'
    ]
  },
  CHECK_LIST_CONFIG: [
    {
      name: 'comerciais',
      label: 'Aceito as condições comerciais acima'
    },
    {
      name: 'pagamentos',
      label: 'Aceito os Termos e Condições de Contratação das Soluções de Pagamento',
      link: '#'
    }
  ]
}
